var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.letters),function(letter){return _c('section',{key:letter.id},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('Paper',{attrs:{"letter":letter}})],1)])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }